/* cSpell:disable */
import { Box, Tooltip } from '@bcp-nextgen-dx-component-factory/design-system';
import { useGetCurrentBreakpoint } from '@hooks';

import { TooltipInnerProps } from './tooltip';

/**
 *
 *
 * @return {*}  {JSX.Element}
 */
export const TooltipAb: React.FC<TooltipInnerProps> = (props: TooltipInnerProps): JSX.Element => {
	const { title, content } = props;
	const { currentView } = useGetCurrentBreakpoint();

	return (
		<Box
			styles={{
				padding: '2px 0 0 3px',
			}}
		>
			<Tooltip
				inset="s5"
				content={
					<Tooltip.Container>
						{title && <Tooltip.Title>{title}</Tooltip.Title>}
						{content && <Tooltip.Description>{content}</Tooltip.Description>}
					</Tooltip.Container>
				}
				triggerMode={currentView === 'bigView' ? 'hover' : 'press'}
			>
				<Tooltip.Trigger size="xxxSmall" />
			</Tooltip>
		</Box>
	);
};
/* cSpell:enable */
